// Catálogo dos componentes que podem ser arrastados para a tela do PDV.

export const COMPONENT_TYPES = [
  { id: "RightMenu", name: "Painel Lateral", type: "RightMenu", icon: "menu" },
  {
    id: "ProductTable",
    name: "Tabela de Produtos",
    type: "ProductTable",
    icon: "table_chart",
  },
  {
    id: "TotalTable",
    name: "Tabela de Totais",
    type: "TotalTable",
    icon: "calculate",
  },
  { id: "Button", name: "Botão de Ação", type: "Button", icon: "smart_button" },
  {
    id: "SearchDesk",
    name: "Busca Mesa",
    type: "SearchDesk",
    icon: "table_restaurant",
  },
  {
    id: "SearchCounter",
    name: "Busca Balcão",
    type: "SearchCounter",
    icon: "countertops",
  },
  {
    id: "SearchCustomerByPhone",
    name: "Busca Cliente por Telefone",
    type: "SearchCustomerByPhone",
    icon: "phone",
  },
  {
    id: "PeriodInfoLabel",
    name: "Informação do Período",
    type: "PeriodInfoLabel",
    icon: "schedule",
  },
  {
    id: "OrderInfoLabel",
    name: "Informação da Conta",
    type: "OrderInfoLabel",
    icon: "receipt",
  },
  {
    id: "CustomerNameLabel",
    name: "Nome do Cliente",
    type: "CustomerNameLabel",
    icon: "person",
  },
  {
    id: "CustomerAddressLabel",
    name: "Endereço do Cliente",
    type: "CustomerAddressLabel",
    icon: "location_on",
  },
  {
    id: "CustomerOriginLabel",
    name: "Origem do Cliente",
    type: "CustomerOriginLabel",
    icon: "travel_explore",
  },
  {
    id: "CurrentDeliveryTable",
    name: "Entregas em Andamento",
    type: "CurrentDeliveryTable",
    icon: "delivery_dining",
  },
  { id: "Logo", name: "Logo", type: "Logo", icon: "image" },
  { id: "Header", name: "Cabeçalho", type: "Header", icon: "horizontal_rule" },
  { id: "Footer", name: "Rodapé", type: "Footer", icon: "horizontal_rule" },
];
